import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Spinner from "../Components/Spinner";
import { useLanguage } from "../Translations/LenguageContext";

const HubspotCallback = () => {
    const {t} = useLanguage()
    const navigate = useNavigate();
    const location = useLocation();
    const [status, setStatus] = useState(t.abilities.finalizing_conn);

    const requestStarted = useRef(false);

    useEffect(() => {
        if (requestStarted.current) return;

        const params = new URLSearchParams(location.search);
        const code = params.get("code");
        const state = params.get("state");
        const redirect_uri = window.location.origin;


        if (code && state) {
            requestStarted.current = true;

            fetch(`${process.env.REACT_APP_GEN_BACKEND_LINK}/confirm_hs_connection`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ code, state, redirect_uri }),
            })
                .then(res => {
                    if (!res.ok) return res.json().then(err => { throw new Error(err.error || "Backend error") });
                    return res.json();
                })
                .then((data) => {
                    if (data.status === "success") {
                        setStatus(t.abilities.connection_success);

                        setTimeout(() => {
                            const org_id = sessionStorage.getItem("org_id")
                            const chat_id = sessionStorage.getItem("chat_id")
                            if (chat_id){
                                navigate(`/e8console/organizations/${org_id}/playground/${chat_id}`);
                            }else{
                                navigate(`/e8console/organizations/${org_id}/abilities`);
                            }
                        }, 4000);
                    }
                })
                .catch(err => {
                    console.error("Connection Error:", err.message);
                    setStatus(t.abilities.connection_error);
                });
        }
    }, [location.search, navigate]);

    return (
        <div className="google_callback_message">
            <div className="google_callback_message_inner">
                <Spinner loading={true} />
                <h2>{status}</h2>
                <p>
                    {status == "Connection successful!" ? (
                        <p dangerouslySetInnerHTML={{__html: t.abilities.conn_succ_subtitle}}></p>
                    ) : status == "Failed to connect" ? (
                        <p dangerouslySetInnerHTML={{__html: t.abilities.conn_error}}></p>
                    ) : (
                        <p dangerouslySetInnerHTML={{__html: t.abilities.test_warn}}></p>
                    )}
                </p>
            </div>
        </div>
    );
};

export default HubspotCallback;